import { initialize } from "launchdarkly-react-client-sdk";
import {
  AUTH0_ORIGIN,
  AUTH0_UPSERVE_ORIGIN,
  LAUNCH_DARKLY_CLIENT_ID,
} from "app_constants";

const darkly = initialize(LAUNCH_DARKLY_CLIENT_ID, {
  kind: "user",
  key: "hq_ui",
});

function upserveDomainEnabled(): boolean {
  return darkly.variation("hq3-upserve-auth-domain", false);
}

function auth0Origin(): string {
  if (upserveDomainEnabled()) {
    return AUTH0_UPSERVE_ORIGIN;
  } else {
    return AUTH0_ORIGIN;
  }
}

export { auth0Origin };
